import type { ShiftEvent } from '@libs/data-access/queries'
import { Badge, Popover, Tooltip } from '@libs/ui/ds'
import {
  useTimeLockReportTranslation,
  usePlanningFormTranslation
} from '@libs/utils/translations'
import { LocationControlPopoverContent } from '@spa/scenes/TimeClockReport/components/Control/LocationControl/LocationControl'
import { isLocationDeleted } from '@spa/scenes/TimeClockReport/components/Control/LocationControl/UnknownLocationControl'
import React from 'react'
import type { FC } from 'react'

type LocationControlBadgeProps = {
  event: ShiftEvent
}
const LocationBadge: FC = () => {
  const { t } = usePlanningFormTranslation()

  return (
    <Badge
      label={t('shiftRealHoursForm.controlBadges.location.badge')}
      size='s'
    />
  )
}

const UnknownLocationControlBadge: FC<LocationControlBadgeProps> = ({
  event
}) => {
  const { t } = usePlanningFormTranslation()
  const { t: timeclockReportTranslation } = useTimeLockReportTranslation()

  const tooltipText =
    event && isLocationDeleted(event.event_occurred_at)
      ? t('shiftRealHoursForm.controlBadges.location.deleted')
      : timeclockReportTranslation('timeClockReport.clockControl.unknown')

  return (
    <Tooltip id={`signature_${event.id}`} label={tooltipText} position='left'>
      <LocationBadge />
    </Tooltip>
  )
}

export const LocationControlBadge: FC<LocationControlBadgeProps> = ({
  event
}) => {
  if (!event.location_coordinates) {
    return <UnknownLocationControlBadge event={event} />
  }

  return (
    <div className='relative'>
      {/* Since we are inside the shift modal, we need to set withinPortal=false and have the popover  inside a relative div so that it is placed correctly */}
      <Popover
        trigger='hover'
        withinPortal={false}
        classNames={{ dropdown: '!top-8 !left-[inherit] right-0' }}
        dropdownPosition='bottom-end'
      >
        <Popover.Target>
          <LocationBadge />
        </Popover.Target>
        <Popover.Dropdown>
          <LocationControlPopoverContent
            location_address={event?.location_address}
            location_coordinates={event?.location_coordinates}
          />
        </Popover.Dropdown>
      </Popover>
    </div>
  )
}
